/**
 * customer-mypage (お客様マイページ) の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 *
 * 🔴 2026-09-14 岩崎さん決定: ここに載せるのは**お客様の画面が呼ぶ API だけ**。
 * - ページ `/customer-mypage`（一覧）と `/customer-mypage/<id>/preview`（下見）はスタッフ用なので載せない。
 *   載せていた間は、未ログインで開くとログイン画面へ移らず「Unauthorized・0件」の枠が出た（2026-09-13 テスト R16）。
 *   お客様の画面は `/customer-portal/...`（app/projects/apps/customer-portal/route-config.ts）。
 * - API は「`/api/customer-mypage` の下ぜんぶ」ではなく1本ずつ書く。一覧 `/api/customer-mypage` と
 *   件数 `/kpi` はスタッフ用。`/api/customer-mypage/` の下に足す API は、ここに書かない限り middleware が
 *   ログインを求める（書き忘れても「お客様が開けない」に倒れ、「ログインなしで読める」には倒れない）。
 *   🔴 例外: 判定は前方一致（`lib/middleware/middleware-impl.ts:8` の `p + '/'`）なので、**下の3本の配下**
 *   （例 `/api/customer-mypage/data/xxx`）はここに書かなくても通る。3本の配下に足すときは route の中で必ず本人確認する。
 * - 下の3本はそれぞれ route の中で本人確認する（resolveCustomerPortalAccess / getCustomerSession）。
 *   呼び出し元（2026-09-14 時点）: お客様の画面 app/projects/apps/customer-portal/frontend/ 配下の hooks・写真ページと、
 *   暖機 app/api/cron/morning-warmup/route.ts（data だけ）。増減は `git grep -n "/api/customer-mypage/"` で確かめる
 */

export const CUSTOMER_MYPAGE_PUBLIC_PATHS = {
  pages: [] as const,
  apis: [
    '/api/customer-mypage/data',
    '/api/customer-mypage/site-photos',
    '/api/customer-mypage/content-masters',
  ] as const,
} as const
